/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T10:54:45.441
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHouseHoldEditInit,
	getRentHouseHoldView
} from '@api/rentmanage/RentHouseHold';

import {
listRentHouseHoldItemInit,
listRentHouseHoldItemByAuthorizations,
deleteRentHouseHoldItem
} from '@api/rentmanage/RentHouseHoldItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHouseHoldEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseHoldView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
